import f from "classnames";
import t, { forwardRef as N, useCallback as E } from "react";
import { IconElement as b } from "../icon-element/icon-element.esm.js";
import { ScreenReaderOnly as v } from "../utils/sr-only.esm.js";
const y = "_plainIconButton_1u904_1 _tappableArea_1kc19_1 _outline--onActive_1oe4d_7 _outline--onFocus_1oe4d_1", R = "_plainIconButton__icon_1u904_23", i = {
  plainIconButton: y,
  plainIconButton__icon: R
}, A = N(
  ({
    ariaLabel: a,
    callback: n,
    className: c,
    color: l = "var(--color-global-black)",
    dataTestId: s,
    disabled: _,
    height: u,
    icon: r,
    srLabel: e,
    size: p = "small",
    width: m,
    ...d
  }, o) => {
    const I = E(
      (B) => {
        n == null || n(B, o);
      },
      [n, o]
    );
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        "aria-label": a,
        className: f(i.plainIconButton, "fuse-plain-icon-button", c),
        "data-testid": s,
        disabled: _,
        onClick: I,
        ref: o,
        ...d
      },
      /* @__PURE__ */ t.createElement(
        b,
        {
          color: l,
          height: u,
          icon: r,
          width: m,
          responsiveSize: p,
          className: `${i.plainIconButton__icon} fuse-plain-icon-button__icon`,
          dataTestId: "fuse-plain-icon-button-icon-test-id"
        }
      ),
      e && /* @__PURE__ */ t.createElement(v, { className: "" }, e)
    );
  }
);
A.displayName = "PlainIconButton";
export {
  A as PlainIconButton
};
